const questionSchema = {
  // Contact information
  firstName: {fieldType: 'short_text'},
  lastName: {fieldType: 'short_text'},
  email: {fieldType: 'short_text'},
  phoneNumber: {fieldType: 'short_text'},
  streetAddress: {fieldType: 'short_text'},
  city: {fieldType: 'short_text'},
  province: {fieldType: 'short_text'},
  postalCode: {fieldType: 'short_text'},

  // Profile
  shortBio: {fieldType: 'short_text'},
  personalBio: {fieldType: 'long_text'},
  caregiverMotivation: {fieldType: 'long_text'},
  profilePhoto: {fieldType: 'file'},

  // Language
  languages: {fieldType: 'array'},

  // Certificate
  certificates: {fieldType: 'array'},

  // Vulnerable sector check
  vulnerableSectorCheck: {fieldType: 'object'},

  // Work history
  workHistory: {fieldType: 'array'},

  // Agreement
  termsAgreement: {fieldType: 'checkbox'},
  certifiesTruthfulness: {fieldType: 'checkbox'},
  understandsPrivacyAndAgreesToConfidentialityPolicies: {fieldType: 'checkbox'},
  certifiesValidAndUpToDateCertifications: {fieldType: 'checkbox'},
  understandsAbuseProhibition: {fieldType: 'checkbox'},
  committedToCodeOfConductAndEthics: {fieldType: 'checkbox'},

};

export default questionSchema;
